export enum EDjangoAppsEndpoints {
  keycloak = 'keycloak',
  CONFIG = 'config',
  accounts = 'accounts',
  /**
   * @deprecated
   */
  auth = 'auth',
  /**
   * @deprecated
   */
  factsheetDeprecated = 'factsheetDeprecated',
  singleStock = 'single-stock',
  news = 'news',
  cache = 'cache',
  otp = 'otp',
  userManagement = 'user-management',
  factsheet = 'fs',
  MULTIFUND_FACTSHEET = 'mffs',
  opsNews = 'opsnews',
  calculator = 'calculator',
  /**
   * @deprecated
   */
  stock = 'stock',
  sectorPerformance = 'sector-performance',
  usageTracking = 'usage-tracking',
  downloadsCenter = 'downloads',

  i18nLocalisation = 'i18n',

  contactForm = 'contact-form',

  notifications = 'notifications',

  tradeOrders = 'orders',

  funds = 'funds',
}
